import { useState } from "react";

import ApplicationOffer from "./Application.Offers.Component";
import BankIdValidFrom from "./BankIDValidFrom.Component";
import History from "./History";
import LsysLoans from "./LsysLoans";
import AutoReview from "./AutoReview";
import UserDetails from "./UserDetails";
import CreditRep from "./CreditRep.Component";
import CreditHistory from "./CreditHistory.Component";
import ListingItem from "../LisingItem";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { moneyFormater } from "../../../../utilities/formaters";

// markup
import List from "@material-ui/core/List";

const ApplicationDetails = (props) => {
  const [activeTab, setActiveTab] = useState(1);

  const handleChangeTab = (event, newValue) => setActiveTab(newValue);

  let application = props.item;
  let accountInfo = props.accountInfos[application.AccountId];
  let lineStyle = { float: "left", whiteSpace: "normal", marginLeft: "20px" };
  let tabStyle = { margin: "5px -5px 0" };

  let extraContentStyle = { position: "relative" };
  let tabContentStyle = { padding: "10px" };

  return (
    <div style={extraContentStyle}>
      <div style={lineStyle}>
        <List>
          <ListingItem primaryText={"General"} />
          <ListingItem
            primaryText={
              application.AppliedAmount
                ? moneyFormater(application.AppliedAmount.Amount) + " kr"
                : "not set"
            }
            secondaryText="Applied amount"
          />
          <ListingItem
            primaryText={
              application.AppliedTerm
                ? application.AppliedTerm + " months"
                : "not set"
            }
            secondaryText="Applied term"
          />
          <ListingItem
            primaryText={application.IsPep ? "yes" : "no"}
            secondaryText="PEP answer"
          />
          <ListingItem
            primaryText={application.LoanBroker}
            secondaryText="Broker"
          />
        </List>
      </div>
      <div style={lineStyle}>
        <ListingItem primaryText={"Loan offers"} />
        <ApplicationOffer LoanOffers={application.LoanOffers} />
      </div>
      <div style={lineStyle}>
        <ListingItem primaryText={"Loan history"} />
        <History application={application} />
      </div>
      <div style={lineStyle}>
        <ListingItem primaryText={"Lsys loans"} />
        <LsysLoans application={application} />
      </div>
      <div style={lineStyle}>
        <ListingItem primaryText={"Auto Reviews"} />
        <AutoReview application={application} />
      </div>
      <div style={lineStyle}>
        <ListingItem primaryText={"Bank Id Valid For"} />
        <BankIdValidFrom validFrom={application.BankIdValidFrom} />
      </div>
      <div style={{ clear: "both" }} />
      <div style={tabStyle}>
        <Tabs value={activeTab} onChange={handleChangeTab}>
          <Tab label="User" value={1} />
          <Tab label="Credit Rep." value={2} />
          <Tab label="History" value={3} />
        </Tabs>
        {activeTab === 1 && (
          <div style={tabContentStyle}>
            <UserDetails
              application={application}
              accountInfo={accountInfo}
              accountId={application.AccountId}
              hideReports={true}
            />
          </div>
        )}
        {activeTab === 2 && (
          <div style={tabContentStyle}>
            <CreditRep application={application} />
          </div>
        )}
        {activeTab === 3 && (
          <div style={tabContentStyle}>
            <CreditHistory accountId={application.AccountId} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationDetails;
